import { MutationTree } from 'vuex';

import { State, Persistente } from './state';
import { GridMutationTypes } from './mutation-types';

export type Mutations<S = State> = {
  [GridMutationTypes.SET_GRIDS](state: S, grid: any): void;
};


export const mutations: MutationTree<State> & Mutations = {
  [GridMutationTypes.SET_GRIDS](state: State, grids: any) {
    state.grids = grids;
    localStorage.setItem('grids', JSON.stringify(Persistente(grids)));
  }
};
